<script>
	import ImageGallery from '../../../_components/ImageGallery.svelte';

	const items = [
		{
			src: '/images/gallery/wi/51382392593.jpg',
			url: 'https://flickr.com/thatconference/51382392593'
		},
		{
			src: '/images/gallery/wi/51382159251.jpg',
			url: 'https://flickr.com/thatconference/51382159251'
		},
		{
			src: '/images/gallery/wi/51381190522.jpg',
			url: 'https://flickr.com/thatconference/51381190522'
		},
		{
			src: '/images/gallery/wi/51381193527.jpg',
			url: 'https://flickr.com/thatconference/51381193527'
		},
		{
			src: '/images/gallery/wi/51381371307.jpg',
			url: 'https://flickr.com/thatconference/51381371307'
		},
		{
			src: '/images/gallery/wi/51381373422.jpg',
			url: 'https://flickr.com/thatconference/51381373422'
		},
		{
			src: '/images/gallery/wi/51381956911.jpg',
			url: 'https://flickr.com/thatconference/51381956911'
		},
		{
			src: '/images/gallery/wi/51381960426.jpg',
			url: 'https://flickr.com/thatconference/51381960426'
		},
		{
			src: '/images/gallery/wi/51382132986.jpg',
			url: 'https://flickr.com/thatconference/51382132986'
		},
		{
			src: '/images/gallery/wi/51382204938.jpg',
			url: 'https://flickr.com/thatconference/51382204938'
		},
		{
			src: '/images/gallery/wi/51382387343.jpg',
			url: 'https://flickr.com/thatconference/51382387343'
		},
		{
			src: '/images/gallery/wi/51382398568.jpg',
			url: 'https://flickr.com/thatconference/51382398568'
		},
		{
			src: '/images/gallery/wi/51382399928.jpg',
			url: 'https://flickr.com/thatconference/51382399928'
		},
		{
			src: '/images/gallery/wi/51382697849.jpg',
			url: 'https://flickr.com/thatconference/51382697849'
		},
		{
			src: '/images/gallery/wi/51382698379.jpg',
			url: 'https://flickr.com/thatconference/51382698379'
		},
		{
			src: '/images/gallery/wi/51382864699.jpg',
			url: 'https://flickr.com/thatconference/51382864699'
		},
		{
			src: '/images/gallery/wi/51382962890.jpg',
			url: 'https://flickr.com/thatconference/51382962890'
		},
		{
			src: '/images/gallery/wi/51382972555.jpg',
			url: 'https://flickr.com/thatconference/51382972555'
		},
		{
			src: '/images/gallery/wi/51383136300.jpg',
			url: 'https://flickr.com/thatconference/51383136300'
		},
		{
			src: '/images/gallery/wi/51381395922.jpg',
			url: 'https://flickr.com/thatconference/51381395922'
		}
	];
</script>

<ImageGallery {items} />
